export function ArrowIcon({ ...props }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9 15.8259V8.1743C9 7.31994 10.0021 6.85903 10.6508 7.41504L15.1142 11.2408C15.5798 11.6399 15.5798 12.3602 15.1142 12.7593L10.6508 16.5851C10.0021 17.1411 9 16.6802 9 15.8259Z" />
    </svg>
  );
}
